import React, { PureComponent } from 'react'
import { Icon,Select, Button,Modal, message,Form,Input,Upload,Spin} from 'antd'
import { connect } from 'react-redux'
import './style/couponSetting.less'
import { getAppSeting,getPayRecommend,discountList,postAppsetting,getGoodsTopic,putPayRecommend } from '_src/api/api'
import { UploadIMGToOss } from '_src/utils/base'
import PrevImg from '_src/components/PrevImg/PrevImg'

const { Option } = Select
const { TextArea } = Input
const uploadButton = (
	<div>
	  <Icon type="plus" />
	  <div className="ant-upload-text">图片上传</div>
	</div>
  )

@Form.create({ name: '' })
class couponSetting extends PureComponent{
	constructor(){
		super()
		this.state={
			coupon:[],
			createModelVisible:false,
			recommend:[],
			discountList:[],
			value:'',
			visible:false,
			info:'',
			fileList:[],
			goodsTopic: [],
			isLoading:true
		}
	}
    componentDidMount(){
		this.loadData()
		this.getDiscount()
    }
    loadData(){
		this.setState({ isLoading: true })
        getAppSeting().then(res =>{
            if(res){
                this.setState({
					coupon:res.data,
					isLoading:false
                })
            }
		}).catch(e => {
			this.setState({
				isLoading:false
			})
		  })
		getPayRecommend().then(res => {
			if(res){
				this.setState({
					recommend:res.data,
					isLoading:false
				})
			}
		}).catch(e => {
			this.setState({
				isLoading:false
			})
		  })
		getGoodsTopic().then({ pageSize: -1 }).then(res => {
			this.setState({
			  goodsTopic: res.data.content
			})
		  }).catch(e => {
			console.log(e)
		  })
	}
	getDiscount(){
		discountList({pageSize:-1}).then(res => {
			if(res){
				this.setState({
					discountList:res.data
				})
			}
		})
	}
	couponShow(key){
		this.setState({
			createModelVisible:true,
			key:key
		})
	}
	couponChange =(v) =>{
		this.setState({
			value:v
		})
	}
	renderGoodTopic = () => {
		return this.state.goodsTopic.map((value, index) => {
		  return <Option key={index} value={value.id}>{value.name}</Option>
		})
	}
	// 预览图片
	handlePreview = (e) => {
		this.PrevImg.show(e.thumbUrl || e.url)
	}
	// 广告图
	handleChange = ({ fileList }) => {
		this.setState({ fileList, upload: true })
		console.log(fileList)
	}
	//设置优惠券
	submit = () =>{
		const {value,key} = this.state
		if(!value){
			message.error('请选择优惠券')
		}else{
			const param = {
				key:key,
				value:value
			}
			const hide = message.loading('提交中')
			postAppsetting(param).then(res => {
				hide()
				if(res.data){
					message.success('提交成功')
					this.loadData()
					this.setState({
						value:'',
						createModelVisible:false
					})
				}
			})
		}
	}
	//设置支付成功广告
	handleSubmit = (e) =>{
		e.preventDefault()
		this.props.form.validateFields((err, values) =>{
			if(!err){
				const pattern = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/
				if (values.adType ===3 && !pattern.test(values.link)) {
					message.error('广告链接地址不正确', 1.5)
					return
				}
				const params = {
					type: values.type,
					link: values.link,
					adType: values.adType
				}
				// 处理图片
				const { fileList, photo, upload, info } = this.state
				const hide = message.loading('添加广告中', 0)
				const advertPr = new Promise((resolve, reject) => {
					if (upload && fileList.length) {
					  // 图片需要上传
					  UploadIMGToOss(fileList[0])
						.then((data) => {
						  if (data) {
							resolve(data)
						  } else {
							message.error('图片上传失败！', 1.5)
						  }
						})
						.catch(function (err) {
						  reject(err)
						  message.error('图片上传失败！', 1.5)
						})
					} else if (photo) {
					  resolve(photo)
					} else {
					  reject(err)
					  message.info('请上传图片')
					}
				})
				advertPr.then(res =>{
					params.photo = res
					putPayRecommend(params).then(res => {
						hide()
						this.setState({
							visible: false,
							upload: false,
							photo: '',
							fileList: [],
						})
						message.success('添加成功！', 1.2, () => {
							this.loadData()
						})
					})
				})
			}
		})
	}
	render(){
		const {coupon,createModelVisible,recommend,discountList,visible,info,fileList,isLoading} = this.state
		const { getFieldDecorator, getFieldsValue } = this.props.form
		const values  = getFieldsValue()
		let adType = values.adType || (info && info.adType)
		const coupon1 = coupon.length>0 && coupon.filter(item => item.key==='coupon1')[0]
		const coupon2 = coupon.length>0 && coupon.filter(item => item.key==='coupon2')[0]
		const coupon3 = coupon.length>0 && coupon.filter(item => item.key==='coupon3')[0]
		const inviteCoupon = coupon.length>0 && coupon.filter(item => item.key==='inviteCoupon')[0]
		const goods1 = coupon.length>0 && coupon.filter(item => item.key==='goods1')[0]
		const goods2 = coupon.length>0 && coupon.filter(item => item.key==='goods2')[0]
		const goods3 = coupon.length>0 && coupon.filter(item => item.key==='goods3')[0]
		const miniApp = coupon.length>0 && coupon.filter(item => item.key==='miniApp')[0]
		const ticket = coupon.length>0 && coupon.filter(item => item.key==='ticket')[0]
		const ad1 = recommend.length>0 && recommend.filter(item => item.type === 1)[0]
		const ad2 = recommend.length>0 && recommend.filter(item => item.type ===2)[0]
		return(
			<div className="couponSetting">
				{isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
				<PrevImg ref={el => this.PrevImg = el} />
				<div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 新用户注册礼包</div>
                    <div className="tab-con">
						<div className="tabTop">
							<div className="item">
								<span>优惠券一</span>
							</div>
							<div className="item">优惠券二</div>
							<div className="item">优惠券三</div>
						</div>
						<div className="tabBot">
							<div className="item">
								<span>{coupon1 && coupon1.getValueInfo?coupon1.getValueInfo.name:null}</span>
								<span className='check' onClick={()=>this.couponShow('coupon1')}>选择</span>
							</div>
							<div className="item">
								{coupon2 && coupon2.getValueInfo? coupon2.getValueInfo.name:null}
								<span className='check' onClick={()=>this.couponShow('coupon2')}>选择</span>
							</div>
							<div className="item">
								{coupon3 && coupon3.getValueInfo? coupon3.getValueInfo.name:null}
								<span className='check' onClick={()=>this.couponShow('coupon3')}>选择</span>
							</div>
						</div>
					</div>
                </div>
				<div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 邀请有礼优惠券</div>
                    <div className="tab-con">
						<div className="tabTop">
							<div className="item">
								<span>优惠券一</span>
							</div>
						</div>
						<div className="tabBot">
							<div className="item">
								<span>{inviteCoupon && inviteCoupon.getValueInfo?inviteCoupon.getValueInfo.name:null}</span>
								<span className='check' onClick={()=>this.couponShow('inviteCoupon')}>选择</span>
							</div>
						</div>
					</div>
                </div>
				<div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 支付成功优惠券</div>
                    <div className="tab-con">
						<div className="tabTop">
							<div className="item">小程序汽车票支付优惠券</div>
							<div className="item">汽车票支付成功优惠券</div>
							<div className="item">商品支付成功优惠券一</div>
							<div className="item">商品支付成功优惠券二</div>
							<div className="item">商品支付成功优惠券三</div>
						</div>
						<div className="tabBot">
							<div className="item">
								{miniApp && miniApp.getValueInfo?miniApp.getValueInfo.name:null}
								<span className='check' onClick={()=>this.couponShow('miniApp')}>选择</span>
							</div>
							<div className="item">
								{ticket && ticket.getValueInfo?ticket.getValueInfo.name:null}
								<span className='check' onClick={()=>this.couponShow('ticket')}>选择</span>
							</div>
							<div className="item">
								{goods1 && goods1.getValueInfo?goods1.getValueInfo.name:null}
								<span className='check' onClick={()=>this.couponShow('goods1')}>选择</span>
							</div>
							<div className="item">
								{goods2 && goods2.getValueInfo?goods2.getValueInfo.name:null}
								<span className='check' onClick={()=>this.couponShow('goods2')}>选择</span>
							</div>
							<div className="item">
								{ goods3 && goods3.getValueInfo?goods3.getValueInfo.name:null}
								<span className='check' onClick={()=>this.couponShow('goods3')}>选择</span>
							</div>
						</div>
					</div>
                </div>
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 支付成功广告</div>
                    <div className="tab-con">
						<div className="tabTop">
							<div className="item">汽车票支付成功广告</div>
							<div className="item">商品支付成功广告</div>
						</div>
						<div className="tabBot">
							<div className="item">
								{ad2 && ad2.goodsName?ad2.goodsName:null}
								<span className='check' onClick={() => {
									if(ad2 && ad2.goodsName){
										const fileList = ad2.photo ? [{ uid: 0, name: 'xxx.png', status: 'done', url: ad2.photo }] : []
										this.setState({
											info:ad2,
											fileList,
											photo:ad2.photo
										})
									}
									this.setState({
										visible:true,
									})
								}}>选择</span>
							</div>
							<div className="item">
								{ad1 && ad1.goodsName?ad1.goodsName:null}
								<span className='check' onClick={() =>{
									if(ad1 && ad1.goodsName){
										const fileList = ad1.photo ? [{ uid: 0, name: 'xxx.png', status: 'done', url: ad1.photo }] : []
										this.setState({
											info:ad1,
											fileList,
											photo:ad1.photo
										})
									}
									this.setState({
										visible:true
									})
								}}>选择</span>
							</div>
						</div>
					</div>
                </div>
				<Modal
					title={'优惠券设置'}
					visible={createModelVisible}
					onCancel={() => {
						this.setState({
						createModelVisible: false,
						})
					}}
					width={400}
					footer={false}
					destroyOnClose
					>
					<Select defaultValue="" style={{width:300}} onChange={this.couponChange}>
						<Option value="">选择</Option>
						{
							discountList && discountList.length>0 ? discountList.map(item => {
							return <Option value={item.id} key={item.id}>{item.name}</Option>
							})
							:null
						}
					</Select>
					<Button type="primary"  disabled={this.state.issubmit} style={{ width: 180, marginLeft: 90,marginTop:50 }} onClick={this.submit}>保存</Button>
				</Modal>
				<Modal
					title={info ? '编辑广告' : '添加广告'}
					visible={visible || false}
					onCancel={() => {
						this.setState({
						visible: false,
						upload: false,
						photo: '',
						info: '',
						fileList: [],
						})
					}}
					width={600}
					footer={false}
					destroyOnClose
					>
				<Form className='push-modal-inner' onSubmit={this.handleSubmit} style={{ paddingLeft: 30 }}>
					<Form.Item label="广告类型" className='flex'>
						{getFieldDecorator('type', {
							rules: [{ required: true, message: '请选择广告类型' }],
							initialValue: info ? info.type : '',
						})(
							<Select placeholder="请选择广告类型" style={{ width: 300, height: 32 }}>
								<Option value={1}>商品</Option>
								<Option value={2}>汽车票</Option>
							</Select>
						)}
					</Form.Item>
					<Form.Item label="跳转类型" className='flex'>
					{getFieldDecorator('adType', {
						rules: [{ required: true, message: '请选择跳转类型' }],
						initialValue: info ? info.adType : '',
					})(
						<Select placeholder="请选择跳转类型" style={{ width: 300, height: 32 }}>
						<Option value={1}>商品详情</Option>
						<Option value={2}>专题</Option>
						<Option value={3}>链接</Option>
						<Option value={4}>旅游详情</Option>
						</Select>,
					)}
					</Form.Item>
					{adType === 1 ? <Form.Item label="商品ID：" className='flex'>
					{getFieldDecorator('link', {
						rules: [{
						required: true,
						message: '请输入商品ID',
						}],
						initialValue: info ? info.link : '',
					})(
						<Input placeholder="输入商品ID" style={{ width: 300 }} />
					)}
					</Form.Item> : null
					}
					{adType === 2 ? <Form.Item label="专题" className='flex'>
					{getFieldDecorator('link', {
						rules: [{ required: true, message: '请选择专题' }],
						initialValue: info ? info.link : '',
					})(
						<Select placeholder="请选择专题" style={{ width: 300, height: 32 }}>
						{this.renderGoodTopic()}
						</Select>,
					)}
					</Form.Item> : null
					}
					{adType === 3 ? <Form.Item label="广告地址：" className='flex'>
					{getFieldDecorator('link', {
						rules: [{
						required: true,
						message: '请输入广告地址',
						}],
						initialValue: info ? info.link : '',
					})(
						<TextArea placeholder="输入广告地址" style={{ width: 300, height: 80 }} autosize={false} />
					)}
					</Form.Item> : null
					}
					{adType === 4 ? <Form.Item label="线路ID：" className='flex'>
					{getFieldDecorator('link', {
						rules: [{
						required: true,
						message: '请输入线路ID',
						}],
						initialValue: info ? info.link : '',
					})(
						<Input placeholder="输入线路ID" style={{ width: 300 }} />
					)}
					</Form.Item> : null
					}
					<Form.Item label="广告封面图：" className='flex'>
					{getFieldDecorator('photo', {
						rules: [{
						required: true,
						message: '请上传广告封面图',
						}],
						initialValue: info ? info.photo : '',
					})(
						<Upload
						action=""
						listType="picture-card"
						fileList={fileList}
						onPreview={this.handlePreview}
						onChange={this.handleChange}
						beforeUpload={() => { return false }}
						>
						{fileList.length >= 1 ? null : uploadButton}
						</Upload>
					)}
					<div> （尺寸：750 * 210）</div>
					</Form.Item>
					<Form.Item>
					<Button type="primary" htmlType="submit" size='large' style={{ width: 300, marginLeft: 120, marginTop: 0 }}>保存</Button>
					</Form.Item>
				</Form>
				</Modal>
			</div>
		)
	}
}
export default connect()(couponSetting)